import React, { Fragment } from 'react';
import {
    Drawer,
    Theme,
    List,
    Collapse
} from '@material-ui/core';
import { StyleRules, createStyles, withStyles } from '@material-ui/core/styles';
import AppHeaderMenuItem from './appHeaderMenuItem';
import { RouteListItem } from '../../interfaces/authorizationInterfaces';

interface AppHeaderMenuProps {
    menuList: RouteListItem[];
    isMenuOpen: boolean;
    updateIsMenuOpen: Function;
    classes?: any;
}

const styles = (theme: Theme): StyleRules => {
    return createStyles({
        drawerPaper: {
            width: '320px'
        },
        [theme.breakpoints.only('xs')]: {
            drawerPaper: {
                width: '250px'
            }
        }
    });
};

const AppHeaderMenu: React.FunctionComponent<AppHeaderMenuProps> = (props: AppHeaderMenuProps): JSX.Element => {
    if (props.isMenuOpen === false) {
        return <Fragment />;
    }

    const renderAppHeaderMenu = (): JSX.Element[] => {
        return props.menuList.map((item: RouteListItem): JSX.Element => {
            const { subRoutes = [] } = item;
            const appHeaderSubMenu = subRoutes.map((subRoute) => {
                return (
                    <Collapse key={subRoute.path} in={true} component='div'>
                        <AppHeaderMenuItem
                            menuItem={subRoute}
                            isNested={true}
                            updateIsMenuOpen={props.updateIsMenuOpen}
                            isDisabled={subRoute.isDisabled === true}
                        />
                    </Collapse>
                );
            });

            return (
                <Fragment key={item.path}>
                    <AppHeaderMenuItem
                        menuItem={item}
                        isNested={false}
                        updateIsMenuOpen={props.updateIsMenuOpen}
                        isDisabled={item.isDisabled === true}
                    />
                    {appHeaderSubMenu}
                </Fragment>
            );
        });
    };

    return (
        <Drawer
            classes={{ paper: props.classes.drawerPaper }}
            open={props.isMenuOpen}
            onClose={(): void => { props.updateIsMenuOpen(false); }}
        >
            <List>
                {renderAppHeaderMenu()}
            </List>
        </Drawer>
    );
};

export default withStyles(styles)(AppHeaderMenu);
